import { defineElement, FC, onDidLoad, useProp } from '@atomify/hooks';
import { addFlyin, flyinStore } from '@source/store/flyins';

const BPDFlyInPanel: FC = ({ element }) => {
    const [, setActive] = useProp<boolean>('active', false);

    onDidLoad(() => {
        if (element.id) {
            addFlyin(element.id);
        }

        flyinStore.subscribe(({ flyins }) => {
            const { active } = flyins[element.id];
            setActive(active);
        });
    });
};

BPDFlyInPanel.props = {
    active: {
        type: Boolean,
        reflectToAttr: true,
    },
};

defineElement('bpd-fly-in-panel', BPDFlyInPanel);
